import type { ReactNode } from 'react'
import { usePage } from '@inertiajs/react'
import Header from '../components/Header'
import Footer from '../components/Footer'
import MetaTags from '../components/MetaTags'
import TimerBar from '../components/tracker/Timer/TimerBar'
import ConfirmEmailBanner from '../components/ConfirmEmailBanner'
import type { SharedProps } from '../types'

// App shell mirroring the old Next.js root layout (Header + main + Footer).
export default function AppLayout({ children }: { children: ReactNode }) {
  const { props } = usePage<SharedProps>()
  const { notice, alert } = props.flash ?? {}

  return (
    <div className="relative flex min-h-screen flex-col bg-brand-bg text-brand-ink">
      <MetaTags />

      {/* 暖色光晕。毛玻璃（.brand-glass）要靠它才看得出层次——纯色底上做毛玻璃
          等于白做。aria-hidden：它不传达任何信息，读屏不该念到它。 */}
      <div className="brand-aura" aria-hidden="true">
        <i />
        <i />
        <i />
      </div>

      {/* 光晕是 fixed z-0，内容整体抬到它上面。isolate 把这一层的层叠上下文
          关起来，页面里再出现 z-index 不会穿到光晕下面去。 */}
      <div className="relative isolate z-10 flex min-h-screen flex-col">
        <Header />
        <TimerBar />
        <main className="container mx-auto flex-grow p-4 pb-[calc(1rem+var(--input-center-space,0px))] transition-[padding-bottom] duration-150">
          <ConfirmEmailBanner />
          {notice && (
            <div className="mb-4 rounded-xl border border-brand-line bg-brand-glass2 p-3 text-sm text-brand-ink">
              {notice}
            </div>
          )}
          {alert && (
            <div className="mb-4 rounded-xl border border-brand-primary bg-brand-primarySoft p-3 text-sm text-brand-primaryDeep">
              {alert}
            </div>
          )}
          {children}
        </main>
        <Footer />
      </div>
    </div>
  )
}
